<div class="incoming-call-container">
  <div class="call-icon-container">
    <mat-icon class="call-icon pulse">phone</mat-icon>
  </div>

  <h1 mat-dialog-title class="call-title" cdkFocusInitial tabindex="-1">Incoming Call</h1>

  <div mat-dialog-content class="call-content">
    <div class="caller-info">
      <p class="caller-name" *ngIf="data.callerName">{{ data.callerName }}</p>
      <p class="caller-number">{{ formattedCallerNumber }}</p>

      <!--
        A static badge, not a `mat-chip-list`: that renders `role="listbox"` with a selected option,
        so a screen reader announces an interactive control for something nobody can interact with.
      -->
      <ng-container *ngIf="isPostDischargeCall">
        <span class="call-type-badge">Post Discharge Call</span>

        <p class="call-type-note">You'll hear call context before being connected to the patient.</p>
      </ng-container>

      <ng-container *ngIf="isWarmTransfer">
        <span class="call-type-badge">Warm Transfer</span>

        <p class="call-type-note" *ngIf="clinicName">From {{ clinicName }}</p>
      </ng-container>
    </div>

    <div class="microphone-warning" *ngIf="microphoneWarning" role="alert">
      <mat-icon class="microphone-warning__icon">mic_off</mat-icon>
      <span>{{ microphoneWarning }} You can answer, but the patient may not hear you.</span>
    </div>
  </div>

  <div mat-dialog-actions class="call-actions">
    <button mat-fab color="warn" class="action-button reject-button" (click)="onReject()" matTooltip="Decline Call">
      <mat-icon>call_end</mat-icon>
    </button>

    <button
      mat-fab
      color="primary"
      class="action-button accept-button"
      (click)="onAccept()"
      matTooltip="Accept Call"
    >
      <mat-icon>phone</mat-icon>
    </button>
  </div>
</div>
